module.exports = __webpack_public_path__ + "static/media/instagram.add7b969.png";